import EnumType from "../shared/EnumType";

const values = {
  Trailer: 0, 
  SelfPropelled: 1
};

export default EnumType.generate(values, "Drilling.MovedBy.");